import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';
import Tracking from '@spotahome/soyuz-tracking';

import { parseQueryParams, stringifyQueryParams } from '../utils/queryParams';

import CallToAction from './CallToAction';
import Autocompleter from './Autocompleter';

import './Search.scss';

const EVENT_CATEGORY = 'SEOLanding';
const EVENT_ACTION = 'Explore';
const POI_KEY = 'poi';

const composeLink = (url, queryStr) =>
  [url, queryStr].filter(Boolean).join('?');

const getNewLinkForCity = (link, city, previousCity) => {
  const [baseLink] = link.split('?');
  const splitPathLink = baseLink.split('/');
  const replacedCityLink = splitPathLink.map(
    path => (path === previousCity ? city : path)
  );

  return replacedCityLink.join('/');
};

const getInitialState = seeMoreLink => {
  const [baseLink, queryParamsStr] = seeMoreLink.split('?');
  const queryParams = parseQueryParams(queryParamsStr);

  return {
    ctaLink: baseLink,
    queryParams
  };
};

class Search extends Component {
  state = {
    city: this.props.currentCity,
    ...getInitialState(this.props.seeMoreLink)
  };

  componentWillMount = () => {
    this.cities = this.props.cities
      ? this.props.cities.reduce(
          (acc, cur) => ({
            ...acc,
            [trans(`landingpage.label.${cur.id}`)]: cur.id
          }),
          {}
        )
      : {};
  };

  getAutocompleterCities = () => Object.keys(this.cities);

  getAutocompleterSelectedCity = () =>
    this.getAutocompleterCities().find(
      key => this.cities[key] === this.state.city
    );

  getCTALink = () =>
    composeLink(
      this.state.ctaLink,
      stringifyQueryParams(this.state.queryParams)
    );

  handleSelectCity = city => {
    const selectedCity = this.cities[city];
    const isInitialCity = selectedCity === this.props.currentCity;
    let ctaLink;
    let queryParams;

    if (isInitialCity) {
      const initialState = getInitialState(this.props.seeMoreLink);
      ctaLink = initialState.ctaLink;
      queryParams = {
        ...this.state.queryParams,
        ...initialState.queryParams
      };
    } else {
      ctaLink = getNewLinkForCity(
        this.state.ctaLink,
        selectedCity,
        this.state.city
      );
      queryParams = {
        ...this.state.queryParams,
        [POI_KEY]: null
      };
    }

    this.setState(
      {
        city: selectedCity,
        ctaLink,
        queryParams
      },
      () => {
        Tracking.DimensionManager.setCity(this.state.city);
      }
    );
  };

  trackNoResult = value => {
    Tracking.ga.sendEvent(
      EVENT_CATEGORY,
      'Select City -- Autocompleter',
      value
    );
  };

  handleCTAClick = () => {
    Tracking.ga.sendEvent(EVENT_CATEGORY, EVENT_ACTION);
  };

  renderCTA = () => (
    <CallToAction link={this.getCTALink()} onClick={this.handleCTAClick} full>
      {trans('landingpage.main_cta_button')}
    </CallToAction>
  );

  render() {
    return (
      <div className="search">
        <div className="search__autocompleter">
          <Autocompleter
            cityNames={this.getAutocompleterCities()}
            initialValue={this.getAutocompleterSelectedCity()}
            onSelectedElement={this.handleSelectCity}
            onNoResults={this.trackNoResult}
          />
        </div>
        <div className="search__cta">{this.renderCTA()}</div>
      </div>
    );
  }
}

Search.propTypes = {
  seeMoreLink: PropTypes.string.isRequired,
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      currencyIsoCode: PropTypes.string
    })
  ).isRequired,
  currentCity: PropTypes.string.isRequired
};

export default Search;
